export default __webpack_public_path__ + "static/media/homePageCustomer.98028712.webp";